/* Style-consultation popup - shows after the visitor has actively browsed the site
   for a cumulative threshold (e.g. 5 or 10 min) across page views. Reuses the theme's
   ModalElement for the centered card + scale-in animation. */
if (!customElements.get('style-consult-modal')) {
  customElements.define(
    'style-consult-modal',
    class StyleConsultModal extends ModalElement {
      constructor() {
        super();
        if (window.location.pathname === '/challenge' || !theme.cookiesEnabled) return;
        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        } else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }

      get shouldLock() { return true; }
      get testMode() { return this.getAttribute('data-test-mode') === 'true'; }
      get threshold() { return this.hasAttribute('data-threshold') ? parseInt(this.getAttribute('data-threshold')) : 300; } // seconds
      get expiry() { return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry')) : 14; } // days
      get cookieName() { return 'concept:style-consult'; }
      get storageKey() { return 'concept:style-consult:elapsed'; }

      init() {
        if (this.initialized) return;
        this.initialized = true;
        if (Shopify.designMode) return;

        // Reopen to show the success/error message after a form submit
        if (this.querySelector('.alert')) { this.load(1); return; }

        // Test mode: ignore cookie + timer, show quickly for preview
        if (this.testMode) { this.load(3); return; }

        // Already shown/dismissed recently
        if (this.getCookie(this.cookieName)) return;

        var self = this;
        var elapsed = 0;
        try { elapsed = parseInt(localStorage.getItem(this.storageKey) || '0', 10) || 0; } catch (e) {}

        if (elapsed >= this.threshold) { this.load(2); return; }

        // Count active seconds (paused while the tab is hidden), persisted across pages
        this.tick = setInterval(function () {
          if (document.hidden) return;
          elapsed += 5;
          try { localStorage.setItem(self.storageKey, elapsed); } catch (e) {}
          if (elapsed >= self.threshold) {
            clearInterval(self.tick);
            self.show();
          }
        }, 5000);
      }

      load(delay) {
        if (Shopify.designMode) return;
        setTimeout(() => this.show(), delay * 1000);
      }

      afterHide() {
        super.afterHide();
        if (this.testMode) { this.removeCookie(this.cookieName); return; }
        this.setCookie(this.cookieName, this.expiry);
      }

      getCookie(name) {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
      }
      setCookie(name, expiry) {
        document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
      }
      removeCookie(name) {
        document.cookie = `${name}=; max-age=0`;
      }
    }
  );
}
